import { render, staticRenderFns } from "./loginboxmobile.vue?vue&type=template&id=167ef3e0&"
import script from "./loginboxmobile.vue?vue&type=script&lang=js&"
export * from "./loginboxmobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports